'use client';

import { Avatar, type AvatarSize } from '../../../components/ui/avatar';
import { cn } from '../../../lib/utils';

export type UserMenuTriggerProps = {
  name: string;
  role?: string;
  avatarSrc?: string;
  avatarAlt?: string;
  avatarSize?: AvatarSize;
  className?: string;
};

/** Static toolbar profile display (no menu / hover / click). */
export function UserMenuTrigger({
  name,
  role,
  avatarSrc,
  avatarAlt = '',
  avatarSize = 'md',
  className,
}: UserMenuTriggerProps) {
  return (
    <div
      className={cn(
        'flex max-w-full min-w-0 items-center gap-3 rounded-xl px-2.5 py-2 sm:px-3',
        className,
      )}
      aria-label={role ? `${name}, ${role}` : name}
    >
      <Avatar
        src={avatarSrc}
        alt={avatarAlt}
        name={name}
        size={avatarSize}
        className='shrink-0'
      />
      <span className='hidden min-w-0 flex-1 flex-col gap-0.5 sm:flex'>
        <span className='truncate text-sm font-semibold leading-tight text-foreground'>
          {name}
        </span>
        {role ? (
          <span className='truncate text-xs leading-tight text-muted-foreground'>
            {role}
          </span>
        ) : null}
      </span>
    </div>
  );
}
